import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorStore, StripePriceProduct } from '@sleipai/sleip-models';

export const StripePriceProductActions = createActionGroup({
  source: 'StripePriceProduct/API',
  events: {
    loadStripePriceProducts: emptyProps(),
    loadStripePriceProductsSuccess: props<{
      stripePriceProducts: StripePriceProduct[];
    }>(),
    loadStripePriceProductsFailure: props<{
      error: ErrorStore | string | null | any;
    }>(),
    addStripePriceProduct: props<{ stripePriceProduct: StripePriceProduct }>(),
    addStripePriceProducts: props<{
      stripePriceProducts: StripePriceProduct[];
    }>(),
    deleteStripePriceProduct: props<{ id: string }>(),
    deleteStripePriceProducts: props<{ ids: string[] }>(),
    clearStripePriceProducts: emptyProps(),
  },
});
